module.exports = __webpack_public_path__ + "static/img/title-en.9a47e368.png";